<template>
	<div class="highlights">
		<h1>Highlights</h1>
	</div>
</template>

<script>
export default {
	name: 'Highlights',
};
</script>

<style lang="scss" scoped>
.highlights {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: red;
}
</style>
